<template>
  <f7-page class="chat">
    <f7-navbar color="black" :sliding="false">
      <f7-nav-left>
        <f7-button
          class="gradient burger show-on-md"
          fill
          large
          round
          panel-toggle="left"
        >
          <f7-icon f7="bars"></f7-icon>
        </f7-button>
      </f7-nav-left>
      <f7-nav-right>
        <user-time></user-time>
        <!-- <f7-link href="/chat-bot" class="margin-right">
          <span class="mr-10">🤖</span>
          Chat Bot
        </f7-link> -->

        <!-- <f7-link
          class="margin-right hide-on-lg"
          href="https://reallang.com/apps/"
          external
          target="_blank"
        >
          <span class="mr-10">🌟</span>
          Our Apps
        </f7-link> -->

        <!-- <f7-link class="logout-link hide-on-lg">
          <f7-icon class="mr-10" f7="square_arrow_right" size="24"></f7-icon>
          {{ $t(`log_out`) }}
        </f7-link> -->
      </f7-nav-right>
    </f7-navbar>

    <!-- <chat-subnavbar slot="fixed" :start="lesson.start"></chat-subnavbar> -->

    <f7-messagebar
      ref="messagebar"
      :placeholder="placeholder"
      :attachments-visible="attachmentsVisible"
      @input="handleInputEvent"
      @blur="hideTyping"
      @keydown.enter.native.exact.prevent
      @keyup.enter.native.exact="send"
      @keydown.enter.shift.native.exact
    >
      <label slot="inner-start" class="chat-attach-file ripple">
        <f7-icon f7="paperclip" color="gray" size="29"></f7-icon>
        <f7-input
          type="file"
          multiple
          :accept="ACCEPT_FILE_TYPE"
          @change="updateAttachments"
        ></f7-input>
      </label>

      <span slot="inner-end" class="messagebar-inner-end">
        <!-- Voice message button -->
        <f7-link
          v-if="!voiceMessage"
          icon-only
          icon-color="gray"
          icon-size="36"
          :class="['ripple', { recording: isRecord }]"
          :icon-f7="isRecord ? 'pause_circle_fill' : 'mic_circle_fill'"
          @click="record"
        >
          <div class="recordVawe"></div>
        </f7-link>

        <f7-link
          v-if="voiceMessage"
          icon-only
          icon-f7="trash_circle_fill"
          icon-color="red"
          icon-size="36"
          @click="voiceMessage = null"
        ></f7-link>

        <!-- Send button -->
        <f7-preloader v-if="attachmentsMessageLoading"></f7-preloader>
        <f7-link
          v-else
          class="ripple"
          icon-only
          icon-f7="arrow_up_circle_fill"
          icon-color="gray"
          icon-size="36"
          @click="send"
        ></f7-link>
      </span>

      <!-- Attachments -->
      <f7-messagebar-attachments>
        <f7-messagebar-attachment
          v-for="(attachment, index) in attachments"
          :key="index"
          :image="attachment.preview"
          @attachment:delete="attachments.splice(index, 1)"
        ></f7-messagebar-attachment>

        <f7-messagebar-attachment class="messagebar-attachment-add-button">
          <label>
            <f7-icon f7="plus" color="white" size="33"></f7-icon>
            <f7-input
              type="file"
              multiple
              :accept="ACCEPT_FILE_TYPE"
              @change="updateAttachments"
            ></f7-input>
          </label>
        </f7-messagebar-attachment>
      </f7-messagebar-attachments>
    </f7-messagebar>

    <f7-messages ref="messages">
      <f7-message
        v-for="(message, index) in messageData"
        :key="index"
        :type="message.type"
        :first="isFirstMessage(message, index)"
        :last="isLastMessage(message, index)"
        :tail="isTailMessage(message, index)"
        :class="{ 'with-mark': message.mark }"
        :avatar="
          message.type === 'received'
            ? `${BASE_PATH}${lesson.teacher.avatar}`
            : ''
        "
      >
        <span v-if="message.text" slot="text" v-html="message.text"></span>

        <span
          v-if="message.isQuestion && message.answers"
          slot="default"
          class="question-button"
        >
          <template v-for="(answer, index2) in message.answers">
            <f7-button
              v-if="answer.type === 'text'"
              :key="index2"
              fill
              large
              :active="false"
              @click="answerTheQuestion(message.id, index2)"
            >
              {{ answer.text }}
            </f7-button>

            <f7-link
              v-if="answer.type === 'image'"
              :key="index2"
              class="ripple"
              @click="answerTheQuestion(message.id, index2)"
            >
              <img :src="`${BASE_PATH}/storage/${answer.image}`" alt="alt" />
            </f7-link>
          </template>
        </span>

        <!-- QUOTE TEMPLATE -->
        <span v-if="message.quote" slot="bubble-start" class="quote-messages">
          <img src="static/quote.svg" alt="quote" />
          <div class="quote-messages-text">{{ message.quote }}</div>
          <div class="quote-messages-info">
            {{ prettyDate(message.quoteDate, 'd.L.yyyy, HH:mm:ss') }}
          </div>
        </span>

        <!-- MARK TEMPLATE -->
        <span v-if="message.mark" slot="bubble-end" class="message-mark-icon">
          {{ message.mark === 'like' ? '👍' : '👎' }}
        </span>

        <!-- IMAGE TEMPLATE -->
        <span
          v-if="message.attachment && message.attachment.type === 'image'"
          slot="image"
        >
          <img
            :src="`${BASE_PATH}${message.attachment.src}`"
            :alt="message.attachment.name"
            @click="openPhotoBrowser(message.attachment.src)"
          />
        </span>

        <!-- URL IMAGE TEMPLATE -->
        <span
          v-if="message.attachment && message.attachment.type === 'image_url'"
          slot="image"
        >
          <img
            :src="message.attachment.src"
            :alt="message.attachment.name"
            @click="
              openPhotoBrowser(message.attachment.src, message.attachment.type)
            "
          />
        </span>

        <!-- AUDIO MESSAGE TEMPLATE -->
        <span
          v-if="message.attachment && message.attachment.type === 'audio'"
          slot="default"
        >
          <audio-player
            :type="message.type"
            :src="`${BASE_PATH}${message.attachment.src}`"
          ></audio-player>
        </span>

        <!-- FILE TEMPLATE -->
        <span
          v-if="
            message.attachment &&
              message.attachment.type !== 'image' &&
              message.attachment.type !== 'image_url' &&
              message.attachment.type !== 'audio'
          "
          slot="default"
        >
          <file-card
            :name="message.attachment.name"
            :src="`${BASE_PATH}${message.attachment.src}`"
            :size="fileSize(message.attachment.size)"
            :type="message.attachment.type"
          ></file-card>
        </span>

        <!-- DATE TEMPLATE -->
        <span slot="end" class="message-time">
          {{ prettyDate(message.date, 'HH:mm:ss') }}
        </span>
      </f7-message>

      <f7-message
        v-if="typing"
        type="received"
        :typing="true"
        :first="true"
        :last="true"
        :tail="true"
        :avatar="`${BASE_PATH}${lesson.teacher.avatar}`"
      ></f7-message>
    </f7-messages>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { BASE_PATH, ACCEPT_FILE_TYPE } from '@/js/const/index.js';
import { prettyDate } from '@/js/helpers/date.js';
import MicRecorder from 'mic-recorder-to-mp3';
import apiRequest from '@/js/helpers/apiRequest.js';
import filePreview from '@/js/helpers/filePreview.js';
import fileSize from '@/js/helpers/fileSize.js';
// import notify from '@/js/helpers/notify.js';
import getAudioDuration from '@/js/helpers/getAudioDuration.js';

import FileCard from '@/components/FileCard.vue';
import AudioPlayer from '@/components/AudioPlayer.vue';
import UserTime from '@/components/UserTime.vue';

export default {
  name: 'Chat',

  components: {
    FileCard,
    AudioPlayer,
    UserTime
  },

  data() {
    return {
      attachments: [],
      voiceMessage: null,
      recorder: null,
      audio: null,
      isRecord: false,
      timerId: null,
      photoBrowserId: null,
      typing: null
    };
  },

  computed: {
    BASE_PATH: () => BASE_PATH,
    ACCEPT_FILE_TYPE: () => ACCEPT_FILE_TYPE,
    prettyDate: () => prettyDate,
    fileSize: () => fileSize,
    roomId() {
      return btoa(
        `${this.user.name}-${this.user.lastName}:${this.lesson.teacher.name}-${this.lesson.id}`
      );
    },

    attachmentsVisible() {
      return this.attachments.length > 0;
    },

    placeholder() {
      return this.attachments.length > 0
        ? this.$t(`page_chat.add_comment`)
        : `${this.$t(`page_chat.message`)}...`;
    },

    photos() {
      const photos = this.messageData
        .filter(
          (message) => message.attachment && message.attachment.type === 'image'
        )
        .map((message) => `${BASE_PATH}${message.attachment.src}`);

      return photos;
    },

    ...mapState({
      user: (state) => state.user.info,
      lesson: (state) => state.lesson.lesson,
      messageData: (state) => state.chat.messages,
      attachmentsMessageLoading: (state) => state.chat.attachmentsMessageLoading
    })
  },

  created() {
    this.subscribeToLessonChannel(this.lesson.id);
  },

  mounted() {
    this.messagebar = this.$refs.messagebar.f7Messagebar;
    this.messages = this.$refs.messages.f7Messages;

    this.recorder = new MicRecorder({
      bitRate: 128
    });
  },

  beforeDestroy() {
    this.hideTyping();
    this.unsubscribeFromLessonChannel(this.lesson.id);
    this.recorder = null;
  },

  methods: {
    subscribeToLessonChannel(lessonId) {
      this.$echo
        .private(`lesson.${lessonId}`)
        .listenForWhisper('typing', (res) => {
          this.typing = res.typing;
        });
    },

    unsubscribeFromLessonChannel(lessonId) {
      this.$echo.leave(`lesson.${lessonId}`);
    },

    isFirstMessage(message, index) {
      const previousMessage = this.messageData[index - 1];
      if (message.isTitle) return false;
      if (
        !previousMessage ||
        previousMessage.type !== message.type ||
        previousMessage.name !== message.name
      )
        return true;
      return false;
    },

    isLastMessage(message, index) {
      const nextMessage = this.messageData[index + 1];
      if (message.isTitle) return false;
      if (
        !nextMessage ||
        nextMessage.type !== message.type ||
        nextMessage.name !== message.name
      )
        return true;
      return false;
    },

    isTailMessage(message, index) {
      const nextMessage = this.messageData[index + 1];
      if (message.isTitle) return false;
      if (
        !nextMessage ||
        nextMessage.type !== message.type ||
        nextMessage.name !== message.name
      )
        return true;
      return false;
    },

    updateAttachments(e) {
      const { files } = e.target;

      for (let file of files) {
        if (file.type.split('/')[0] === 'image') {
          const reader = new FileReader();

          reader.onload = (e) => {
            this.attachments.push({
              preview: e.target.result,
              file: file
            });
          };
          reader.readAsDataURL(file);
        } else {
          filePreview({
            name: file.name,
            type: file.type,
            size: fileSize(file.size)
          }).then((preview) => {
            this.attachments.push({
              preview,
              file: file
            });
          });
        }
      }
    },

    createPhotoBrowser() {
      this.photoBrowserId = this.$f7.photoBrowser.create({
        theme: 'dark',
        photos: this.photos
      });
    },

    async openPhotoBrowser(src) {
      const index = this.photos.indexOf(`${BASE_PATH}${src}`);

      if (this.photoBrowserId) {
        this.photoBrowserId.destroy();

        await this.$nextTick();
        this.createPhotoBrowser();
        await this.$nextTick();
        this.photoBrowserId.open(index);
      } else {
        this.createPhotoBrowser();
        await this.$nextTick();
        this.photoBrowserId.open(index);
      }
    },

    record() {
      if (!this.isRecord) {
        this.recorder
          .start()
          .then(() => {
            this.isRecord = true;
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.recorder
          .stop()
          .getMp3()
          .then(([buffer, blob]) => {
            this.isRecord = false;

            const file = new File(buffer, 'voice-message.mp3', {
              type: blob.type,
              lastModified: Date.now()
            });

            getAudioDuration(blob, (duration) => {
              const minutes = Math.floor(duration / 60);
              const seconds = duration - minutes * 60;

              this.voiceMessage = {
                file,
                duration: {
                  minutes,
                  seconds
                }
              };
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    showTyping() {
      this.$echo.private(`lesson.${this.lesson.id}`).whisper('typing', {
        typing: true,
        userId: this.user.id
      });
    },

    hideTyping() {
      this.$echo.private(`lesson.${this.lesson.id}`).whisper('typing', {
        typing: false
      });
    },

    handleInputEvent(e) {
      if (!e.target.value) {
        this.hideTyping();

        return;
      }

      this.showTyping();
    },

    async answerTheQuestion(questionId, answerId) {
      try {
        const body = new FormData();

        body.append('lesson_id', this.lesson.id);
        body.append('ask_id', questionId);
        body.append('answer_id', answerId);

        await apiRequest('question/answer', 'POST', body, true);
      } catch (error) {
        console.log(error);
      }
    },

    async send() {
      if (this.voiceMessage && this.voiceMessage.file) {
        await this.sendMessage({
          lessonId: this.lesson.id,
          attachment: this.voiceMessage.file,
          audio: true
        });

        // this.$refs.messagebar.f7Messagebar.focus();
        this.voiceMessage = null;
      }

      const text = this.messagebar
        .getValue()
        .replace(/\n/g, '<br>')
        .trim();

      const messagesToSend = [];

      if (text.trim().length) {
        messagesToSend.push({
          text
        });
      }

      if (this.attachments.length) {
        this.attachments.forEach((attachment) => {
          messagesToSend.push({
            file: attachment.file
          });
        });
      }

      if (messagesToSend.length === 0) {
        return;
      }

      messagesToSend.forEach(async (value) => {
        const type = Object.keys(value)[0];

        switch (type) {
          case 'text': {
            await this.sendMessage({
              lessonId: this.lesson.id,
              text: value.text
            });

            break;
          }

          case 'file': {
            await this.sendMessage({
              lessonId: this.lesson.id,
              attachment: value.file
            });

            break;
          }
        }
      });

      this.$refs.messagebar.f7Messagebar.clear();
      this.attachments = [];
      this.hideTyping();
      if (text.length) this.$refs.messagebar.f7Messagebar.focus();
    },

    ...mapActions({
      sendMessage: 'chat/sendMessage'
    })
  }
};
</script>

<style lang="less">
.chat {
  --f7-page-bg-color: #f7f7fb;
  --f7-message-received-bg-color: #ffffff;
  --f7-messagebar-bg-color: #ffffff;
  --f7-messagebar-inner-padding-left: 15px;
  --f7-messagebar-inner-padding-right: 15px;

  .toolbar-inner {
    padding-top: 16px;
    padding-bottom: 15px;
    border-top: 1px solid #d5d8dd;

    a.icon-only {
      min-width: 0;
      min-height: 0;
      height: 36px;
    }
  }

  .messagebar-area {
    margin: 0 5px 0 0;
  }

  .message {
    max-width: 100%;
    width: calc(100% - 18px);

    --f7-message-bubble-padding-vertical: 4px;
    --f7-message-bubble-line-height: 24px;
    --f7-message-bubble-padding-horizontal: 15px;

    &.with-mark {
      margin-bottom: 25px;

      .message-bubble {
        padding-bottom: 25px;
      }
    }

    .message-mark-icon {
      position: absolute;
      bottom: -12px;
      left: 15px;
      width: 30px;
      height: 30px;
      font-size: 15px;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 50%;
      box-shadow: 0 2px 3px 0 rgba(210, 210, 210, 1);
    }

    .message-image {
      img {
        width: 100% !important;
      }
    }
  }

  .message-time {
    font-weight: 300;
    font-size: 16px;
    color: #d5d8dd;
  }

  .message-sent,
  .message-received {
    .message-bubble {
      -webkit-mask-box-image: none !important;
    }
  }

  .message-sent {
    margin-right: calc(18px + var(--f7-safe-area-right));

    .message-time {
      margin-right: auto;
      margin-left: calc(18px + var(--f7-safe-area-left));
    }

    .message-content {
      margin-left: 18px;
    }

    .message-bubble {
      padding-right: var(--f7-message-bubble-padding-horizontal);
      box-shadow: 0 2px 4px 0 rgba(210, 210, 210, 0.5);
      border-radius: var(--f7-message-bubble-border-radius) 0 0
        var(--f7-message-bubble-border-radius);
    }

    .message-image:last-child img {
      border-radius: var(--f7-message-bubble-border-radius) 0 0
        var(--f7-message-bubble-border-radius);
    }

    .file-preview {
      border-radius: var(--f7-message-bubble-border-radius) 0 0
        var(--f7-message-bubble-border-radius);
    }

    &.message-first {
      .message-bubble {
        border-radius: var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius) 0
          var(--f7-message-bubble-border-radius);
      }

      .message-image:last-child img {
        border-radius: var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius) 0
          var(--f7-message-bubble-border-radius);
      }

      .file-preview {
        border-radius: var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius) 0
          var(--f7-message-bubble-border-radius);
      }
    }

    &.message-tail {
      .message-bubble {
        border-radius: var(--f7-message-bubble-border-radius) 0
          var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius);

        .message-image:last-child img {
          border-radius: var(--f7-message-bubble-border-radius) 0
            var(--f7-message-bubble-border-radius)
            var(--f7-message-bubble-border-radius);
        }

        .file-preview {
          border-radius: var(--f7-message-bubble-border-radius) 0
            var(--f7-message-bubble-border-radius)
            var(--f7-message-bubble-border-radius);
        }
      }
    }
  }

  .message-received {
    margin-left: calc(18px + var(--f7-safe-area-left));

    .message-avatar {
      margin-right: 10px;
      align-self: flex-start;
    }

    .message-time {
      margin-left: auto;
      margin-right: calc(18px + var(--f7-safe-area-right));
    }

    .message-content {
      margin-right: 18px;
    }

    .message-bubble {
      padding-left: var(--f7-message-bubble-padding-horizontal);
      border-radius: 0 var(--f7-message-bubble-border-radius)
        var(--f7-message-bubble-border-radius) 0;
    }

    .message-image {
      margin-left: calc(-1 * var(--f7-message-bubble-padding-horizontal));

      &:last-child img {
        border-radius: 0 var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius) 0;
      }
    }

    .file-preview {
      border-radius: 0 var(--f7-message-bubble-border-radius)
        var(--f7-message-bubble-border-radius) 0;
    }

    .audio-player {
      .button {
        border-radius: 50%;
      }

      .icon {
        color: #ff6189;
      }
    }

    &.message-first {
      .message-bubble {
        border-radius: var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius) 0;

        .message-image:last-child img {
          border-radius: var(--f7-message-bubble-border-radius)
            var(--f7-message-bubble-border-radius)
            var(--f7-message-bubble-border-radius) 0;
        }
      }

      .file-preview {
        border-radius: var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius) 0;
      }
    }

    &.message-tail:not(.message-typing) {
      .message-bubble {
        border-radius: 0 var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius);

        .message-image:last-child img {
          border-radius: 0 var(--f7-message-bubble-border-radius)
            var(--f7-message-bubble-border-radius)
            var(--f7-message-bubble-border-radius);
        }
      }

      .file-preview {
        border-radius: 0 var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius)
          var(--f7-message-bubble-border-radius);
      }
    }

    .question-button {
      max-width: 210.688px;

      img {
        width: 100%;
        border-radius: 6px;
      }

      a.button.button-fill {
        margin-bottom: 4px;

        --f7-button-bg-color: var(--f7-theme-color-tint) !important;
        --f7-button-large-height: 40px;
        --f7-button-large-font-size: 16px;
        --f7-button-padding-horizontal: 10px;

        p {
          margin: 0;
        }
      }
    }
  }
}

.chat-attach-file {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  align-self: flex-end;
  margin-bottom: 2px;
  margin-left: -5px;

  input {
    display: none;
  }
}

html.device-with-keyboard {
  .messagebar {
    padding-bottom: calc(var(--f7-safe-area-bottom) - 34px);
  }
}

.messagebar {
  &.hide-text-area {
    textarea {
      display: none !important;
    }
  }
}

.messagebar-attachment-add-button {
  width: 70px;
  background-color: rgba(127, 130, 134, 0.9);

  .messagebar-attachment-delete {
    display: none;
  }

  label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    input {
      display: none;
    }
  }

  .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.messagebar-inner-end {
  display: flex;
  align-items: center;
  width: 77px;
  flex-shrink: 0;
  align-self: flex-end;

  a.link {
    margin-left: 0 !important;

    &:not(:last-of-type) {
      margin-right: 5px !important;
    }
  }

  .preloader {
    width: 24px;
    height: 25px;
    margin-left: 10px;
  }
}

.link.recording {
  .recordVawe {
    position: absolute;
    top: calc(50% - 18px);
    left: calc(50% - 18px);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: darken(#ff6189, 10%);
    /* background-color: #ff001f; */
    z-index: -1;
    animation-name: wave;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 1.35s;
  }

  i {
    z-index: 2;
  }
}

.quote-messages {
  margin-bottom: 15px;
  padding-bottom: 5px;
  text-align: left;
  border-bottom: 1.5px solid rgba(#000000, 0.3);

  &-text {
    margin-top: 5px;
    font-style: italic;
    font-size: 16px;
    font-weight: 500;
  }

  &-info {
    margin-top: 5px;
    font-size: 14px;
    color: rgba(#000000, 0.6);
  }
}

@keyframes wave {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}

/* .webrtc-video-container {
  position: absolute;
  top: 110px;
  width: 100%;
  left: 0;
  z-index: 1000000;
} */
</style>
